// 8000ms because the animation lasts 8s, see spinmachine.component.scss
export const DELAY_ON_SPIN = 7400;
